import React, { useEffect, useState } from 'react';
import { fetchRecordByKey } from "../../services/IndexedDBUtil";
import { DATABASE_NAME, STORE_NAME } from '../../services/constants';
import { getSalesPersons } from '../../services/ApiManageWorkflow';
import { displayMessage } from '../../Utils/helper';
import axios from 'axios';
import Loader from '../common/Loader';
import AuthService from '../../services/AuthService';

const { REACT_APP_API_BASE_URL } = process.env;

export default function Report3({ Product, Location, Workflow }) {
  const [filteredData, setFilteredData] = useState([]);
  const [salesPersons, setSalesPersons] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const init = async () => {
      let indexedDBResponse = await fetchRecordByKey(DATABASE_NAME, STORE_NAME, 'WFForecastResult');
      if (indexedDBResponse?.success) {
        let _data = indexedDBResponse.record?.data;
        let skuData = _data.cities.find(cityData => cityData.city === Location)?.data.find(skuData => skuData.sku === Product)?.data;
        console.log("Forecast Data:", skuData);
        
        setFilteredData(skuData);
        await fetchSalesPersons(Location);
      }
    };

    init();
  }, [Location, Product]);

  function capitalizeFirstLetter(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Format date to dd--yy-mm
  function formatDateDDYYMM(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const dd = String(date.getDate()).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${dd}--${yy}-${mm}`;
  }

  async function fetchSalesPersons(cityname) {
    let _cityName = capitalizeFirstLetter(cityname);
    let result = await getSalesPersons(_cityName);
    setSalesPersons(result || []);
  }

  // Handler for selecting a team member
  function handleSelectMember(e) {
    const sp_id = e.target.value;
    if (!sp_id) return;
    const member = salesPersons.find(p => p.sp_id === sp_id);
    if (member && !selectedMembers.some(m => m.sp_id === member.sp_id)) {
      setSelectedMembers([...selectedMembers, member]);
    }
    // Reset dropdown
    e.target.value = "";
  }

  // Handler for removing a member
  function handleRemoveMember(sp_id) {
    setSelectedMembers(selectedMembers.filter(m => m.sp_id !== sp_id));
  }

  // ✅ SEND FUNCTIONALITY - Fixed
  async function handleSendMembers() {
    if (selectedMembers.length === 0) {
      displayMessage('warning', 'No Members Selected', 'Please select at least one team member');
      return;
    }

    // Check if workflow is already approved
    if (Workflow?.approval_status?.toLowerCase() === "approved") {
      displayMessage('info', 'Already Approved', 'This workflow is already approved');
      return;
    }

    setIsLoading(true);
    try {
      const url = `${REACT_APP_API_BASE_URL}/send_email_f_skus`;
      
      // Extract sp_ids from selected members
      const sp_ids = selectedMembers.map(member => member.sp_id);
      
      const payload = {
        sp_ids: sp_ids,
        workflow_ids: [`${Workflow.workflow_id}`],
        Authorization: AuthService.getAccessToken(),
        access_token: AuthService.getAccessToken()
      };

      console.log("Sending payload:", payload);

      const response = await axios.post(url, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      console.log("Response:", response.data);

      if (response.data.failed === 0) {
        displayMessage('success', 'Mail Sent Successfully', `Sent to ${selectedMembers.length} team member(s)`);
        // Optionally clear selection after successful send
        // setSelectedMembers([]);
      } else {
        displayMessage('danger', 'Error', 'Failed to send emails');
      }
    } catch (error) {
      console.error("Error sending emails:", error.message);
      displayMessage('danger', 'Error', 'Failed to send emails. Please try again.');
    }
    setIsLoading(false);
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-4 sm:p-6 lg:p-8">
      <div className="max-w-full mx-auto space-y-6 lg:space-y-8">
        {/* Header Section */}
        <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 border-2 border-[#1F4280] transform hover:scale-[1.02] transition-all duration-300">
          <h2
            className="text-3xl sm:text-3xl lg:text-4xl font-bold mb-2"
            style={{ fontFamily: 'Poppins, sans-serif', color: '#0F1116' }}
          >
            Forecast Report
          </h2>
          <p
            className="text-base sm:text-lg lg:text-xl"
            style={{ fontFamily: 'Inter, sans-serif', color: '#6B7280', fontStyle: 'italic' }}
          >
            Comprehensive forecast analysis for {Product} in {Location}
          </p>
        </div>

        {/* Forecast Data Table */}
        <div className="bg-white rounded-2xl shadow-2xl hover:shadow-3xl p-6 lg:p-8 border-2 border-[#032B4E] transform hover:scale-[1.01] transition-all duration-300 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-40 h-40 lg:w-60 lg:h-60 bg-gradient-to-br from-[#032B4E]/5 to-transparent rounded-full -translate-y-20 translate-x-20"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 lg:w-48 lg:h-48 bg-gradient-to-tr from-[#032B4E]/3 to-transparent rounded-full translate-y-16 -translate-x-16"></div>
          
          <div className="relative z-10 h-full flex flex-col">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#032B4E] mb-4 lg:mb-6 flex items-center gap-3">
              <span style={{fontFamily: 'Poppins, sans-serif', color: '#0F1116'}}>Forecast Timeline</span>
            </h3>
            
            {filteredData && filteredData.length > 0 ? (
              <div className="overflow-hidden rounded-xl border-2 border-[#1F4280] shadow-xl hover:shadow-2xl transition-all duration-300 bg-white">
                <table className="w-full">
                  <thead className="bg-[#032B4E] text-white">
                    <tr>
                      {filteredData.map((elem, index) => (
                        <th 
                          key={index} 
                          className="px-2 sm:px-3 lg:px-4 py-2 lg:py-3 text-center text-xl sm:text-2xl lg:text-3xl font-bold tracking-wide drop-shadow-sm relative overflow-hidden whitespace-nowrap"
                          style={{fontFamily: 'Poppins, sans-serif', letterSpacing: '0.5px'}}
                        >
                          <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
                          <div className="relative z-10 flex items-center justify-center">
                            <span>{formatDateDDYYMM(elem.frequency_year)}</span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y-2 divide-gray-200">
                    <tr>
                      {filteredData.map((elem, index) => (
                        <td 
                          key={index} 
                          className="px-2 sm:px-3 lg:px-4 py-4 lg:py-5 text-center relative group hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-300"
                        >
                          <div className="flex flex-col items-center justify-center">
                            <div className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#032B4E] group-hover:scale-110 transform transition-all duration-300 tracking-tight" style={{fontFamily: 'Poppins, sans-serif'}}>
                              {elem.forecast?.toLocaleString() || elem.forecast}
                            </div>
                            <div className="w-2/3 h-1 mt-2 bg-gradient-to-r from-[#032B4E] to-[#b8842f] rounded-full opacity-80 group-hover:opacity-100 transition-all duration-300 shadow-lg transform group-hover:scale-105"></div>
                          </div>
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="flex items-center justify-center py-16 text-gray-500 bg-white rounded-xl border-2 border-[#1F4280] flex-grow">
                <div className="text-center transform hover:scale-105 transition-transform duration-300">
                  <div className="text-6xl mb-4 animate-bounce">📊</div>
                  <p className="text-xl font-semibold text-[#032B4E]">No forecast data available</p>
                  <p className="text-sm text-gray-600 mt-2">Please check your data source and try again</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Sales Team Assignment */}
        <div className="bg-white rounded-2xl shadow-2xl hover:shadow-3xl p-6 lg:p-8 border-2 border-[#032B4E] transform hover:scale-[1.02] transition-all duration-300 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-40 h-40 lg:w-60 lg:h-60 bg-gradient-to-br from-[#032B4E]/5 to-transparent rounded-full -translate-y-20 translate-x-20"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 lg:w-48 lg:h-48 bg-gradient-to-tr from-[#032B4E]/3 to-transparent rounded-full translate-y-16 -translate-x-16"></div>
          
          <div className="relative z-10">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#032B4E] mb-8 lg:mb-12 flex items-center space-x-4 lg:space-x-6 drop-shadow-sm">
              <span style={{fontFamily: 'Poppins, sans-serif', color: '#0F1116'}}>Sales Team Assignment</span>
            </h3>

            {/* Check if already approved */}
            {Workflow?.approval_status?.toLowerCase() === "approved" ? (
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 border-2 border-green-300 shadow-lg">
                <div className="flex items-center justify-center gap-4">
                  <span className="text-5xl">✅</span>
                  <div>
                    <p className="text-2xl font-bold text-green-700">Workflow Approved</p>
                    <p className="text-lg text-green-600 mt-2">This workflow has already been approved and processed.</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-gradient-to-br from-[#032B4E]/5 to-blue-50/50 rounded-2xl shadow-xl p-8 lg:p-10 hover:shadow-2xl transition-all duration-300 border-2 border-gray-200">
                <div className="w-full">
                  <div className="space-y-6">
                    {/* Selection Card */}
                    <div className="bg-white/90 backdrop-blur-sm rounded-xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#032B4E]">
                      <div className="space-y-5">
                        <h4 className="text-2xl font-semibold text-[#032B4E] flex items-center gap-4">
                          <span className="text-3xl">👥</span>
                          <span style={{fontFamily: 'Poppins, sans-serif', color: '#0F1116'}}>Select Sales Team Member</span>
                        </h4>
                        
                        <div className="relative">
                          <select
                            className="w-full px-6 py-4 rounded-xl bg-gradient-to-r from-[#032B4E]/5 to-blue-100/30 border-2 border-gray-200 text-[#032B4E] font-medium focus:outline-none focus:ring-2 focus:ring-[#1F4280] appearance-none cursor-pointer shadow-md hover:shadow-lg transition-all duration-300 text-lg"
                            onChange={handleSelectMember}
                            defaultValue=""
                          >
                            <option value="">Choose a team member...</option>
                            {salesPersons.map((person, index) => (
                              <option key={index} value={person.sp_id}>{person.sp_name}</option>
                            ))}
                          </select>
                          <div className="absolute right-6 top-1/2 transform -translate-y-1/2 text-[#032B4E]/70 pointer-events-none">
                            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Selected Members Card */}
                    <div className="bg-white/90 backdrop-blur-sm rounded-xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#032B4E]">
                      <div className="space-y-5">
                        <h4 className="text-2xl font-semibold text-[#032B4E] flex items-center gap-4">
                          <span className="text-3xl">📋</span>
                          <span style={{fontFamily: 'Poppins, sans-serif', color: '#0F1116'}}>
                            Selected Team Members ({selectedMembers.length})
                          </span>
                        </h4>

                        <div className="space-y-3">
                          {selectedMembers.length > 0 ? (
                            <div className="flex flex-wrap gap-3 overflow-x-auto py-2">
                              {selectedMembers.map((person, index) => (
                                <div 
                                  key={index}
                                  className="inline-flex items-center bg-gradient-to-r from-[#032B4E]/5 to-blue-100/30 border-2 border-gray-200 rounded-full px-4 py-2 shadow-md hover:shadow-lg transition-all duration-300"
                                  style={{maxWidth: 'max-content'}}
                                >
                                  <span className="font-semibold text-[#032B4E] text-lg" style={{fontFamily: 'Poppins, sans-serif'}}>{person.sp_name}</span>
                                  <button
                                    className="ml-2 text-red-500 hover:bg-red-50 p-1 rounded-full transition-all duration-300"
                                    title="Remove member"
                                    onClick={() => handleRemoveMember(person.sp_id)}
                                  >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                  </button>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center py-8 text-gray-500 bg-[#032B4E]/5 rounded-xl border-2 border-dashed border-gray-300">
                              <p className="text-lg font-medium">No team members selected yet</p>
                              <p className="text-base mt-2 text-gray-400">Use the dropdown above to select members</p>
                            </div>
                          )}
                        </div>

                        {/* Send Button */}
                        <div className="flex justify-end mt-6">
                          {isLoading ? (
                            <div className="px-8 py-4">
                              <Loader size={'large'} />
                            </div>
                          ) : (
                            <button
                              className={`px-8 py-4 text-white text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 flex items-center gap-3 ${
                                selectedMembers.length === 0 
                                  ? 'bg-gray-400 cursor-not-allowed opacity-50' 
                                  : 'bg-[#368E60] hover:bg-[#28794b] focus:ring-[#368E60]/50'
                              }`}
                              onClick={handleSendMembers}
                              disabled={selectedMembers.length === 0 || isLoading}
                            >
                              <span>Send to {selectedMembers.length} Member{selectedMembers.length !== 1 ? 's' : ''}</span>
                              <span className="text-xl">→</span>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
